module.exports = __webpack_public_path__ + "img/intro-locating.bff04fcc.png";